import axios from '@/utils/api'
import store from '@/store'

const actions = {
  async getItems ({ commit }, { tipoCadastro, numeroPagina }) {
    const usuario = await store.dispatch('auth/getUsuario')

    const data = await axios({
      url: `central/cadastro/list`,
      method: 'POST',
      data: {
        idUsuario: usuario.id,
        tipoCadastro: tipoCadastro,
        numeroPagina: numeroPagina
      }
    })

    return data
  },

  async getItemsProcessoFisico ({ commit }, { tiposCadastro, numeroPagina, limite }) {
    const usuario = await store.dispatch('auth/getUsuario')

    const data = await axios({
      url: `central/cadastro/list/processo/fisico?page=${numeroPagina}&size=${limite}`,
      method: 'POST',
      data: {
        idUsuario: usuario.id,
        tiposCadastro,
        numeroPagina: numeroPagina
      }
    })

    return data
  },

  async count ({ commit }, tipoCadastro) {
    const usuario = await store.dispatch('auth/getUsuario')

    const data = await axios({
      url: `central/cadastro/count/${usuario.id}/${tipoCadastro}`,
      method: 'GET'
    })

    return data
  },

  async delete ({ commit }, idCadastro) {
    await axios({
      url: `central/cadastro/${idCadastro}`,
      method: 'DELETE'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/listagem.js